import { createSlice } from "@reduxjs/toolkit";
import { deleteEmployee } from "services/employee/employee";

const initialState = {
    employee : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}
export const deleteEmployeeSlice = createSlice({
    name: 'delete employee',
    initialState,
    extraReducers: {
        [deleteEmployee.pending]: (state) => {
            state.employee.isLoading = true;
        },
        [deleteEmployee.fulfilled]: (state, { payload }) => {
            state.employee.isLoading = false;
            state.employee.isSuccess = true;
            state.employee.data = payload;
        },
        [deleteEmployee.rejected]: (state, { payload }) => {
            state.employee.isLoading = false;
            state.employee.isSuccess = false;
            state.employee.errorMessage = payload
        }
    }
})
export default deleteEmployeeSlice.reducer;